import AttributeList from "./AttributeList";
export default AttributeList;
